import { SearchSelectProps } from 'views/mutual/searchSelector';
import { PageStep } from '../hooks';
import { useEffect, useState } from 'react';
// import { useGetPersonalAccountDetailInfoQuery } from 'views/utils/graphql/graphql';
import { useGlobalLoadingHandler } from 'views/mutual/globalLoading/hook';
import { usePersonalAccountEstablishStore　} from 'views/templates/personalAccountOpen/hooks';

import {
  FatcaStatus,
  findOccupationName,
  findPersonalBusinessContentName,
  findDomesticRealEstatePurposeName,
} from 'views/utils/enums';
import { isEmpty } from 'lodash';
import { formErrorScroll } from 'views/mutual/formErrorScroll';
import { CountryOfResidence, Nationality, usePersonalAccountAdvancedQuestion } from 'views/templates/personalAccountOpen/advanceQuestion/hooks';
import { AuthModeSelectType } from 'views/templates/personalAccountOpen/customerInfo/hooks';
import { AccountType } from 'views/templates/module/bankDetailsInput/hooks';
import { ImportantPublicWorkerType } from 'views/templates/personalAccountOpen/customerInfo/hooks';
import { Gender, useCustomerInfo } from 'views/templates/personalAccountOpen/customerInfo/hooks';
import { useGetAccountDetailInfoQuery } from 'views/utils/graphql/graphql';


export enum SelectPersonalItem {
  CustomerInfo = 'お客様情報'
}

let SelectPersonalList: SelectPersonalItem[] = (Object.keys(SelectPersonalItem) as (keyof typeof SelectPersonalItem)[]).map((key) => {
  return SelectPersonalItem[key];
});

export const useUpdatePersonalAccountPage = (
  pageStep: PageStep,
  setPageStep: React.Dispatch<React.SetStateAction<PageStep>>,
) => {
  const { showLoading, hideLoading } = useGlobalLoadingHandler();

  const [selected, setSelected] = useState<SelectPersonalItem>(SelectPersonalItem.CustomerInfo);
  // const { add, param, clear } = useUpdateStore();
  const { add, param, clear } = usePersonalAccountEstablishStore();
  const questionInfo = usePersonalAccountAdvancedQuestion({ isUpdate: true, setPageStep });
  const customerInfo = useCustomerInfo({ isUpdate: true});


  const [accountDetail, getAccountDetail] = useGetAccountDetailInfoQuery({
    variables: {},
    requestPolicy: 'network-only',
    pause: true,
  });

  // SMS認証が終わってからアカウント情報を取得する
  // 初期時に取得するとSMS認証しなくてもネットワークを見れば個人情報が見れてしまうので
  useEffect(() => {
    if (pageStep === PageStep.UPDATE && !accountDetail.data) {
      getAccountDetail();
    }
  }, [pageStep]);

  useEffect(() => {
    if (accountDetail.fetching) {
      showLoading();
    } else {
      hideLoading();
    }
    if (!accountDetail.data || !accountDetail.data.GetAccountDetailInfo) return;

    const info = accountDetail.data.GetAccountDetailInfo;

    clear();
    add({        
        uniqueId: null,
        identificationQuestion: null,// 要らないが型エラーになるので適当に
        mailAddressQuestion: null,//後で変更
        selfieQuestion: null,// 要らないが型エラーになるので適当に
        personalInformation: false,// 要らないが型エラーになるので適当に
        generalTermsCondition: false,// 要らないが型エラーになるので適当に
        nationality: false,// 要らないが型エラーになるので適当に
        countryOfResidence: false,// 要らないが型エラーになるので適当に
        birthdate:null,//要らないが型エラーになるので適当に
        confirmResponsibility: info.ConfirmResponsibility ?? false,
        customerFirstName: info.DealerFirstName ?? '',
        customerLastName: info.DealerLastName ?? '',
        customerFirstNameKana: info.DealerFirstNameKana ?? '',
        customerLastNameKana: info.DealerLastNameKana ?? '',
        gender: Gender.None,//要らないが型エラーになるので適当に
        customerPostCode: info.PostCode ?? '',
        customerPrefecture: info.Prefecture ?? '',
        customerCityCountry: info.CityCountry ?? '',
        customerTownStreetAddress: info.TownStreetAddress ?? '',
        hasNoCustomerTownStreetAddress: info.TownStreetAddress ? false : true,
        customerBuildingNameAndRoomNumber: info.BuildingNameAndRoomNumber ?? '',
        customerMobilePhone: info.DealerMobilePhoneNumber ?? '',
        customerHomePhone: info.ContactPhoneNumber ?? '',
        customerFaxNumber: info.ContactFaxNumber ?? '',
        customerMailAddress: info.DealerMailAddress ?? '',
        customerConfirmMailAddress: info.DealerMailAddress ?? '',
        occupation : info.Occupation?.map((x) => {
          return {
            label: findOccupationName(x!) ?? '',
            checked: true,
          };
        }) ?? [],
        occupationOtherText: info.OccupationOtherText ?? '',
        customerMainBusinessContent: findPersonalBusinessContentName(info.PersonalMainBusinessContent!) ?? '',
        customerMainBusinessContentOtherText: info.PersonalMainBusinessContentOtherText ?? '',
        customerOtherBusinessContent: findPersonalBusinessContentName(info.PersonalOtherBusinessContent!) ?? '',
        customerOtherBusinessContentOtherText: info.PersonalOtherBusinessContentOtherText ?? '',
        purpose : info.DomesticRealEstatePurpose?.map((x) => {
          return {
            label: findDomesticRealEstatePurposeName(x!) ?? '',
            checked: true,
          };
        }) ?? [],
        purposeOtherText : info.DomesticRealEstatePurposeOtherText ?? '',
        fatca: info.Fatca ?? FatcaStatus.None,
        importantPublicWorker: info.ImportantPublicWorker ?? ImportantPublicWorkerType.None,
        bankName: info.TransferBankName ?? '',
        branchName: info.TransferBranchName ?? '',
        accountType : info.TransferAccountType ?? AccountType.None,
        accountNumber : info.TransferAccountNumber ?? '',
        accountHolderName : info.TransferAccountHolderName ?? '',
        invoiceNumber: info.InvoiceNumber ?? '',
        hasNoInvoiceNumber : info.InvoiceNumber ? false : true,
        electronicDocumentAgreement: true,// バリデーションエラー回避
        electronicDocumentAgreementDateTime: '', // 要らないが型エラーになるので適当に// 要らないが型エラーになるので適当に
        authMode: info.TwoFactorAuthenticationType ?? AuthModeSelectType.None,  
    });
  }, [accountDetail]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [selected, pageStep]);

  const onSubmit = async (selected: SelectPersonalItem) => {
    switch (selected) {
      case SelectPersonalItem.CustomerInfo:
        return isEmpty(await customerInfo.formik.validateForm());
      default:
        return true;
    }
  };

  const executeConfirm = async () => {
    const valid = await onSubmit(selected as SelectPersonalItem);
    if (!valid) {
      formErrorScroll();
      return;
    }

    add({
      ...param,
      ...questionInfo.formik.values,
      ...customerInfo.formik.values,
    });

    setPageStep(PageStep.CONFIRM);
  };

  const selectProps: SearchSelectProps = {
    selectedOption: selected,
    setSelectedOption: async (select) => {
      const valid = await onSubmit(selected as SelectPersonalItem);
      if (valid) {
        setSelected(select as SelectPersonalItem);
      } else {
        formErrorScroll();
      }
    },
    options: SelectPersonalList,
  };

  const templatePageProps = {
    isUpdate: true,
    setPageStep,
  };

  const isMailChanged = (updateMail: string) => {
    return updateMail !== accountDetail!.data!.GetAccountDetailInfo!.DealerMailAddress;
  };

  return {
    selectProps,
    setSelected,
    executeConfirm,
    templatePageProps,
    questionInfo,
    customerInfo,
    isMailChanged,
  };
};